import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { SharedDocument } from '../../../models/share/share';
import { ExplainModuleEnum } from 'src/app/core/user/user.model';

@Component({
  selector: 'app-share-panel',
  templateUrl: './share-panel.component.html',
  styleUrls: ['./share-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class SharePanelComponent {
  @Input({ required: true }) document!: SharedDocument;
  @Input() withExportPanel: boolean = false;
  @Output() toggle = new EventEmitter<boolean>();
  protected readonly ExplainModuleEnum = ExplainModuleEnum;
}
